export class Alert {

  type: AlertType;

  message: string;

  hasSuffix: boolean

  translateParams: Record<string, any>;

  constructor(type: AlertType, message: string, translateParams = {}, hasSuffix = false) {
    this.type = type;
    this.message = message;
    this.hasSuffix = hasSuffix;
    this.translateParams = Object.assign({br: '<br>'}, translateParams);
  }
}

export enum AlertType {
  Primary = 'primary',
  Info = 'info',
  Light = 'light',
  Danger = 'danger',
  Warning = 'warning',
  Success = 'success'
  // others if needed
}
